import { Grid } from '@mui/material';
import { AvatarPlaceHolder } from '../../../placeholders/avatar.placeholder';
import { TextPlaceholder } from '../../../placeholders/text.placeholder';
import { usePercentageBarRowStyles } from './percentage-bar-row.styles';

export function PercentageBarRowPlaceholder() {
  const classes = usePercentageBarRowStyles({});
  return (
    <Grid
      className={classes.root}
      container
      spacing={2}
      sx={{
        alignItems: 'center'
      }}
    >
      <Grid>
        <AvatarPlaceHolder diameter={32} />
      </Grid>
      <Grid size="grow">
        <Grid container sx={{ flexDirection: 'column' }}>
          <Grid className={classes.barWrapper}>
            <TextPlaceholder fontSize={6} fullWidth style={{ borderRadius: '3px', marginTop: 0, marginBottom: 0 }} />
          </Grid>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'flex-end'
            }}
          >
            <Grid>
              <TextPlaceholder fontSize={14} width="30px" style={{ marginTop: 0, marginBottom: 0 }} />
            </Grid>
            <Grid>
              <TextPlaceholder fontSize={11} width="60px" style={{ marginTop: 0, marginBottom: 0 }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
